import { PlateElement, type PlateElementProps } from '@udecode/plate/react';

export function CodeLineElement(props: PlateElementProps) {
  return <PlateElement {...props} />;
}
